<mat-dialog-content id="print-section">
<p>
  <!-- HEADER -->
</p>
<table class="background" style="width: 100%; height: 100%;" border="0" cellspacing="0" align="center"
  bgcolor="#565656">
  <tbody>
    <tr>
      <td>
        <table class="container" style="width: 727px;" border="0" cellspacing="0" cellpadding="0" align="center" bgcolor="#565656">
          <tbody>
            <tr>
              <td>
                <table class="headerTable" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td><img src="https://www.firstmac.com.au/media/emails/crumbs/fmc-equipmentfinance-logo.png" />
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <table align="center">
                        <tbody>
                          <tr>
                            <td style="font-size: 24px; font-family: Arial; color: #FFFFFF;">
                              <span style="font-size: 18px; font-weight: bold;">YOUR CAR LOAN QUOTE RESULTS</span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="#dddddd">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" align="center">
                  <tbody>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td style="font-size: 12px; font-family: Arial; color: #252525;"><span
                          style="font-size: 18px; font-weight: bold;">{{data.brokerName}}</span> <br /><br />Here is a record of your recent car loan quote completed with Firstmac Car Loans.
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
                <!--end of salutation-->
              </td>
            </tr>
            <tr>
              <td bgcolor="#f2f2f2">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" cellpadding="0"
                  align="center">
                  <tbody>
                    <tr>
                      <td style="font-size: 11px; font-family: Arial; color: #252525;"><span
                          style="font-size: 18px; font-weight: bold;">Broker details</span> <br /><br />
                        <table style="font-size: 12px; font-family: Arial; color: #252525;" border="0" cellspacing="0"
                          cellpadding="0">
                          <tbody>
                            <tr>
                              <td style="width: 110px;"><strong>Originator</strong></td>
                              <td>{{data.originator}}</td>
                            </tr>
                            <tr>
                              <td style="width: 110px;"><strong>Broker</strong></td>
                              <td>{{data.broker}}</td>
                            </tr>
                            <tr>
                              <td style="width: 110px;"><strong>Broker Contact</strong></td>
                              <td>{{data.contact}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
                <!--end of salutation-->
              </td>
            </tr>
            <tr>
              <td bgcolor="#f2f2f2">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" align="center">
                  <tbody>
                    <tr>
                      <td style="border-top: solid 1px #000; line-height: 0;">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="#f2f2f2">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" cellpadding="0"
                  align="center">
                  <tbody>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td style="font-size: 11px; font-family: Arial; color: #252525;"><span
                          style="font-size: 18px; font-weight: bold;">Customer details</span> <br /><br />
                        <table style="font-size: 12px; font-family: Arial; color: #252525;" border="0" cellspacing="0"
                          cellpadding="0">
                          <tbody>
                            <tr>
                              <td style="width: 110px;"><strong>Name</strong></td>
                              <td>{{data.customerName}}</td>
                            </tr>
                            <tr>
                              <td style="width: 110px;"><strong>Email</strong></td>
                              <td>{{data.customerEmail}}</td>
                            </tr>
                            <tr>
                              <td style="width: 110px;"><strong>Phone</strong></td>
                              <td>{{data.customerPhone}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
                <!--end of salutation-->
              </td>
            </tr>
            <tr>
              <td bgcolor="#f2f2f2">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" align="center">
                  <tbody>
                    <tr>
                      <td style="border-top: solid 1px #000; line-height: 0;">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td bgcolor="#f2f2f2">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" cellpadding="0"
                  align="center">
                  <tbody>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td style="font-size: 11px; font-family: Arial; color: #252525;"><span
                          style="font-size: 18px; font-weight: bold;">Loan details</span> <br /><br />
                        <table style="font-size: 12px; font-family: Arial; color: #252525;" border="0" cellspacing="0"
                          cellpadding="0">
                          <tbody>
                            <tr>
                              <td style="width: 110px;"><strong>Product</strong></td>
                              <td>{{data.product}}</td>
                            </tr>
                            <tr>
                              <td style="width: 110px;"><strong>Purpose</strong></td>
                              <td>{{data.purpose}}</td>
                            </tr>
                            <tr>
                              <td style="width: 110px;"><strong>Description</strong></td>
                              <td>{{data.description}}</td>
                            </tr>
                            <tr>
                              <td style="width: 110px;"><strong>Variant</strong></td>
                              <td>{{data.variant}}</td>
                            </tr>
                            <tr>
                              <td style="width: 110px;"><strong>Is Green?</strong></td>
                              <td>{{data.isGreen}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
                <!--end of salutation-->
              </td>
            </tr>
            <tr>
              <td bgcolor="#f2f2f2">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" cellpadding="0"
                  align="center">
                  <tbody>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td align="left"><strong>Amount</strong></td>
                      <td align="right">{{data.loanAmount}}</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="border-top: solid 1px #000; line-height: 0;" colspan="2">&nbsp;</td>
                    </tr>
                    <!-- <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td align="left"><strong>GST not financed</strong></td>
                      <td align="right">{{data.gstNotFinanced}}</td>
                    </tr> -->
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td align="left"><strong>Deposit</strong></td>
                      <td align="right">{{data.depositAmount}}</td>
                    </tr>
                    <!-- <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td align="left"><strong>Insurances</strong></td>
                      <td align="right">{{Insert handlebar}}</td>
                    </tr> -->
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td align="left"><strong>Subtotal</strong></td>
                      <td align="right">{{data.subTotal}}</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td align="left"><strong>Application fee</strong></td>
                      <td align="right">{{data.applicationFee}}</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td align="left"><strong>Origination fee</strong></td>
                      <td align="right">{{data.originationFee}}</td>
                    </tr>
                    <tr *ngIf="data.brokerage" style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td align="left"><strong>Brokerage</strong></td>
                      <td align="right">{{data.brokerage}}</td>
                    </tr>
                    <tr>
                      <td colspan="2">&nbsp;</td>
                    </tr>
                    <tr>
                      <td colspan="2">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
                <!--end of salutation-->
              </td>
            </tr>
            <tr>
              <td bgcolor="#dddddd">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" cellpadding="0"
                  align="center">
                  <tbody>
                    <tr>
                      <td colspan="2">&nbsp;</td>
                    </tr>
                    <tr>
                      <td style="font-size: 11px; font-family: Arial; color: #252525;" colspan="2"><span
                          style="font-size: 18px; font-weight: bold;">Result</span> <br /><br /></td>
                    </tr>
                    <!-- <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="line-height: 30px;" align="left"><strong>Net monthly repayment</strong></td>
                      <td style="line-height: 30px;" align="right">{{data.netMonthlyRepayment}}</td>
                    </tr> -->
                    <!-- <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="border-top: solid 1px #000; line-height: 0;" colspan="2">&nbsp;</td>
                    </tr> -->
                    <!-- <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="line-height: 30px;" align="left">&nbsp;</td>
                      <td style="line-height: 30px;" align="right">GST {{ data.GST}}</td>
                    </tr> -->
                    <!-- <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="border-top: solid 1px #000; line-height: 0;" colspan="2">&nbsp;</td>
                    </tr> -->
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="line-height: 30px;" align="left"><strong>Total monthly repayments</strong></td>
                      <td style="line-height: 30px;" align="right">{{data.totalMonthlyRepayment}}</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="border-top: solid 1px #000; line-height: 0;" colspan="2">&nbsp;</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="line-height: 30px;" align="left"><strong>Term in months</strong></td>
                      <td style="line-height: 30px;" align="right">{{data.termInMonths}}</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="border-top: solid 1px #000; line-height: 0;" colspan="2">&nbsp;</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="line-height: 30px;" align="left"><strong>Interest Rate</strong></td>
                      <td style="line-height: 30px;" align="right">{{data.interestRate}}%</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="border-top: solid 1px #000; line-height: 0;" colspan="2">&nbsp;</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="line-height: 30px;" align="left"><strong>Total Interest</strong></td>
                      <td style="line-height: 30px;" align="right">{{data.totalInterest}}</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="border-top: solid 1px #000; line-height: 0;" colspan="2">&nbsp;</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="line-height: 30px;" align="left"><strong>Total Repayments</strong></td>
                      <td style="line-height: 30px;" align="right">{{data.totalRepayment}}</td>
                    </tr>
                    <!-- <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="border-top: solid 1px #000; line-height: 0;" colspan="2">&nbsp;</td>
                    </tr>
                    <tr style="font-size: 12px; font-family: Arial; color: #252525;">
                      <td style="line-height: 30px;" align="left"><strong>Total interest</strong></td>
                      <td style="line-height: 30px;" align="right">{{data.totalInterest}}</td>
                    </tr> -->
                    <tr>
                      <td colspan="2">&nbsp;</td>
                    </tr>
                    <tr>
                      <td style="text-align: center;" colspan="2"><span
                          style="font-size: 12px; font-family: Arial; color: #252525;"><em>This quote is valid for the
                            next 30 days and will expire on {{ data.expiration | date: 'longDate' }}</em></span></td>
                    </tr>
                    <tr>
                      <td colspan="2">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
                <!--end of salutation-->
              </td>
            </tr>
            <!-- <tr>
              <td bgcolor="#f2f2f2">
                <table class="salutation" style="width: 570px;" border="0" cellspacing="0" align="center">
                  <tbody>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td style="font-size: 12px; font-family: Arial; color: #252525;"><span
                          style="font-size: 18px; font-weight: bold;">Next Steps</span> <br /><br />Please contact
                        {{data.broker}} to get the application process started.</td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr> -->
          </tbody>
        </table>
        <!--end of container-->
      </td>
    </tr>
  </tbody>
</table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial (click)="print()" class="fmc-button-primary">Print</button>
</mat-dialog-actions>
